module.exports = __webpack_public_path__ + "img/horizontal_4_7_3.0f1810c4.png";